import { atom } from 'jotai';

export const $TTNewsroomTitle = atom<string>('TikTok Statement on DC Circuit Court of Appeals Decision');

$TTNewsroomTitle.debugLabel = '$TTNewsroomTitle';
